import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { Agent } from 'src/app/static-data/models/consts/agents.static-data';
import { AgentStaticDataService } from 'src/app/static-data/services/agents-static-data.service';
import { KeyDate } from '../../product-summary/key-dates-modal/key-dates-type.const';

@Pipe({
  name: 'filterEntities'
})
export class FilterEntitiesPipe implements PipeTransform {

  constructor(private agentStaticDataService: AgentStaticDataService) {
  }

  transform(agentType: string): Observable<KeyDate[]> {
    if (!agentType) {
      return;
    }
    
    return this.agentStaticDataService.agents$
      .pipe(
        take(1), 
        map((agents: Agent[]) => agents.filter((agent: Agent) => agent.type === agentType)),
        map((agents: Agent[]) => agents.map((agent: Agent) => ({ id: agent.entityName, displayValue: agent.entityName, lei: agent.lei })))
      );
  }

}
